import React from 'react';
import { committeeMembers } from '../mockData';

const Leadership = () => {
  const generalPresident = committeeMembers.find(member => member.position === "General President");
  const otherMembers = committeeMembers.filter(member => member.position !== "General President");

  return (
    <div className="page-container leadership-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div 
          className="page-hero-bg" 
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1650480929348-64f04d51db40?w=1920)' }}
        >
          <div className="page-hero-overlay" />
        </div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">Leadership & Executive Committee</h1>
          <p className="page-hero-subtitle">
            Meet the leaders guiding United Christian Fellowship
          </p>
        </div>
      </section>

      {/* General President Section */}
      {generalPresident && (
        <section className="president-spotlight">
          <div className="container">
            <div className="president-spotlight-content">
              <div className="president-spotlight-image">
                <img 
                  src={generalPresident.image} 
                  alt={generalPresident.name}
                />
                <div className="president-glow-effect" />
              </div>
              <div className="president-spotlight-text">
                <h2 className="section-title">General President</h2>
                <h3 className="president-name">{generalPresident.name}</h3>
                <div className="president-bio">
                  <p>
                    As our General President, {generalPresident.name.split(' ')[1]} provides visionary 
                    leadership and spiritual guidance to United Christian Fellowship. With a heart for 
                    unity and a passion for God's kingdom, our General President champions collaboration 
                    across churches and denominations.
                  </p>
                  <p>
                    Under this leadership, UCF has grown into a movement that brings together believers 
                    from diverse backgrounds, fostering spiritual growth, authentic worship, and community 
                    transformation throughout Edmonton and beyond.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Executive Committee Section */}
      <section className="committee-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Executive Committee 2025-2026</h2>
            <p className="section-subtitle">
              Our dedicated team working together to advance God's kingdom
            </p>
          </div>

          <div className="committee-grid">
            {otherMembers.map(member => (
              <div key={member.id} className="committee-member-card">
                <div className="member-image-wrapper">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="member-image"
                  />
                  <div className="member-image-overlay" />
                </div>
                <div className="member-info">
                  <h4 className="member-name">{member.name}</h4>
                  <p className="member-position">{member.position}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Leadership Values */}
      <section className="leadership-values">
        <div className="container">
          <div className="values-intro">
            <h2 className="section-title">Our Leadership Values</h2>
            <p>
              Our leadership team is committed to serving with integrity, humility, and a passion 
              for God's glory.
            </p>
          </div>
          
          <div className="values-list">
            <div className="value-item">
              <h4>Servant Leadership</h4>
              <p>Leading by example and serving the body of Christ with humility</p>
            </div>
            <div className="value-item">
              <h4>Unity & Collaboration</h4>
              <p>Working together across denominational lines for God's kingdom</p>
            </div>
            <div className="value-item">
              <h4>Biblical Foundation</h4>
              <p>Grounding all decisions and teachings in God's Word</p>
            </div>
            <div className="value-item">
              <h4>Spirit-Led Ministry</h4>
              <p>Depending on the Holy Spirit for wisdom and direction</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Leadership;
